/**
 *
 * PractitionerTypeSelect
 *
 */
import React, { memo } from 'react';

import { Control, Controller, useWatch } from 'react-hook-form';

import { toSentenceCase } from 'lib/utils/strings';

import { RadioGroup } from 'app/components/RadioGroup';
import { ButtonStyled } from 'app/components/ButtonStyled';
import { FormHeader, FormButtonContainer } from 'app/components/MultiStepForm/styles';

import { AccountTypeEnum } from 'types/common';
import { BaseText } from 'styles/__typography';

interface Props {
  title?: string;
  subtitle?: string;
  next?: () => void;
  control: Control<any, any>;
}

export const PractitionerTypeSelect = memo(({ title, subtitle, next, control }: Props) => {
  const practitionerType = useWatch({
    control,
    name: 'practitionerType',
  });

  return (
    <>
      {title && <FormHeader>{title}</FormHeader>}
      {subtitle && (
        <BaseText fontFamily="Inter" fontSize={3} color="text.secondary" opacity="70%" mb={8}>
          {subtitle}
        </BaseText>
      )}
      <Controller
        name="practitionerType"
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <RadioGroup
            title="What type of practitioner are you?"
            options={[
              { value: AccountTypeEnum.Therapist.toUpperCase(), label: toSentenceCase(AccountTypeEnum.Therapist) },
              { value: AccountTypeEnum.Coach.toUpperCase(), label: toSentenceCase(AccountTypeEnum.Coach) },
            ]}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
          />
        )}
      />
      <FormButtonContainer mt={6}>
        <ButtonStyled variant="primary" minWidth="90px" onClick={next} disabled={!practitionerType}>
          Continue
        </ButtonStyled>
      </FormButtonContainer>
    </>
  );
});
